import script from "./clinic-definitions.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-definitions.vue?vue&type=script&setup=true&lang=js"

import "./clinic-definitions.vue?vue&type=style&index=0&id=ca45b4fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca45b4fc"]])

export default __exports__